<template>
    <v-col cols="12" lg="6">
        <span class="headline">Role</span>
        <bit-page :breadcrumbs="breadcrumbs"></bit-page>
        <v-row align="center" class="white mt-3 pa-3" no-gutters>
            <span class="title green--text text--darken-3">Role</span>
            <v-col class="d-flex mb-3" cols="12">
                <v-divider></v-divider>
            </v-col>

            <v-col cols="12" sm="6" class="px-2">
                <v-text-field
                        dense
                        label="Naziv"
                        outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="px-2 mt-4">
                <span class="title green--text text--darken-3">Dozvole</span>
            </v-col>
            <v-col cols="12">
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Globalna podesavanja"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Jezici"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Meni"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Stranice"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Kategorije"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Dokumenta"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Objekti"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Fotografije"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Vijesti"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Subscribers"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2 mt-4">
                <v-select clearable
                        dense
                        label="Korisnici"
                        :items="dozvole"
                        outlined
                ></v-select>
            </v-col>
            <v-col cols="12" class="mt-2">
                <v-row justify="center">
                    <v-btn color="primary" tile depressed>Snimi</v-btn>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
	import bitPage from "../../../components/layout/page";

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Korisnici',
					disabled: false,
					to: {name: 'korisnici'},
				},
				{
					text: 'Role',
					disabled: false,
					to: '/korisnici/roles',
				},
				{
					text: 'Dodavanje nove role',
					disabled: true
				},
			],
			items: [],
            dozvole: [
                'Restrict',
                'Read',
                'Write'
            ]
		}),
	}
</script>
